
import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const About = () => {
  return (
    <div className="pt-24 min-h-screen">
      <div className="container-section">
        <motion.div 
          className="max-w-6xl mx-auto"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="section-title text-center mb-12">O Projektu</h1>
          
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ x: -20, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              <img 
                src="/lovable-uploads/dfe497e8-3d2c-466a-a4d8-c95208eb1240.png" 
                alt="V3D Studio Svěrák" 
                className="w-full rounded-lg shadow-xl object-cover"
              />
            </motion.div>
            
            <div>
              <p className="text-foreground/80 mb-6 leading-relaxed">
                Jsme studenti Strojnické SPŠS Vsetín, kteří vyvinuli inovativní multifunkční svěrák s otočným mechanismem a vyměnitelnými čelistmi.
              </p>
              
              <div className="tech-card mb-6">
                <h3 className="text-xl font-bold mb-4">Technické specifikace</h3>
                <ul className="space-y-2 text-foreground/80">
                  <li>• Tělo: PTA filament, 5mm stěna</li>
                  <li>• Čelisti: PTA + PETG</li>
                  <li>• Šrouby: M4 x 40 mm, M4 x 20 mm</li>
                  <li>• Výstuž: Gumová, průměr 6 mm</li>
                </ul>
              </div>
              
              <div className="flex gap-4">
                <Link to="/technical-details" className="btn-primary">
                  Technické detaily <ArrowRight size={18} />
                </Link>
                <Link to="/gallery" className="px-6 py-2 border border-tech-blue/50 rounded-md text-tech-blue hover:bg-tech-blue/10 transition-colors">
                  Galerie projektu
                </Link>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default About;
